import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
//may delete these 2 if not used
import PreviewCompatibleImage from './PreviewCompatibleImage'
import ReactMarkdown from 'react-markdown'
import { AnchorLink } from'gatsby-plugin-anchor-links'
import RedButton from '../components/RedButton'
import Carousel from './CarouselWithStatic'


const Container = styled.div`
position:relative;
width:100%;
height:400px;
margin:auto;

& > h2 {
    text-align:center;
    font-family:Montserrat;
    font-style:italic;
    color:var(--tmain);
    font-size:24px;
    margin-bottom:25px;
    @media(min-width:601px) {
      font-size:28px;
    }
}
`

const SlideElement = styled.div`
position:relative;
width:${props => props.width}px;
margin:0 ${props => props.margin}px;

display:flex;
flex-direction:column;
align-items:center;
gap:15px;
`

const Image = styled(AnchorLink)`
position:relative;
width:${props => props.width}px;
height:${props => props.width}px;
float:left;

& > * {
    width:100%;
    height:100%;
}
`


const Abteilungen = ({data}) => {

  return(
    <Container>
      <h2>{data.header}</h2>
      <Carousel width={240} elementCount={data.list.length}>
      {
        data.list.map((item,i) => (
          <SlideElement key={i} width={200} margin={20}>
            <Image width={200}>
              <PreviewCompatibleImage imageInfo={item}/>
            </Image>
            <RedButton href={item.link}>{item.text}</RedButton>
          </SlideElement>
        ))
      }
      </Carousel>
    </Container>
  )
}

Abteilungen.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.string,
    list: PropTypes.arrayOf( PropTypes.shape({
      text: PropTypes.string,
      image: PropTypes.oneOfType( [PropTypes.object, PropTypes.string]),
      link: PropTypes.string,
    })),
  }),
}


export default Abteilungen